import Keycloak from 'keycloak-js'

let KEYCLOAK_INSTANCE = null

const connectKeycloak = async({ url, realm, clientId, refreshInSeconds = 30 } = {}) => {
    const keycloakConfig = {
        url,
        realm,
        clientId
    }

    const initOptions = {
      useNonce: true,
      checkLoginIframe: false,
    }

    KEYCLOAK_INSTANCE = new Keycloak(keycloakConfig)

    return KEYCLOAK_INSTANCE.init(initOptions)
    .then(authenticated => {
      if (authenticated) {
        setInterval(() => {
          KEYCLOAK_INSTANCE.updateToken(900).catch(() => KEYCLOAK_INSTANCE.logout())
        }, refreshInSeconds * 1000)
      }
      return KEYCLOAK_INSTANCE
    })
    .catch(err => console.error('Failed to initialize adapter:', err))
}

const useKeycloak = () => {
    if (!KEYCLOAK_INSTANCE) {
        throw 'connectKeycloak() needs to be called first'
    }

    return KEYCLOAK_INSTANCE
}

export {
    connectKeycloak,
    useKeycloak
}